/**
 * Planes, suscripciones y flujo de pago.
 */
export const planChangeModal = {
  title: '¿Cambiar de plan?',
  confirmSubtitle: (current: string, next: string) =>
    `Tienes el plan ${current} activo. ¿Confirmas el cambio a ${next}?`,
  currentPlan: 'Plan actual',
  newPlan: 'Nuevo plan',
  paymentMethod: 'Método de pago',
  changeCost: 'Costo del cambio',
  totalToPay: 'Total a pagar ahora',
  free: 'Gratis',
  cancel: 'Cancelar',
  confirmFree: 'Confirmar cambio gratis',
  continueToPay: 'Continuar al pago',
  transbank: 'Transbank (Webpay)',
  mercadopago: 'Mercado Pago',
  khipu: 'Khipu',
} as const;

export const subscriptionPlansPage = {
  title: 'Planes de Suscripción',
  subtitle: 'Elige el plan que mejor se adapte a tus necesidades',
  footerNote:
    'Todos los planes incluyen soporte por email y actualizaciones automáticas. Puedes cambiar de plan en cualquier momento desde tu perfil.',
} as const;

export const subscriptionPlansHeader = {
  trialExpiredTitle: '⚠️ Tu período de prueba ha finalizado',
  trialExpiredSubtitle: 'Suscríbete a un plan para continuar',
  trialActiveTitle: '🎉 Estás en período de prueba gratuita',
  daysRemaining: (days: number) => `Te quedan ${days} día${days !== 1 ? 's' : ''}`,
  activeSubscription: (planName: string) => `Tienes una suscripción activa (${planName})`,
  trialEndsOn: (date: string) => `Tu período de prueba vence el ${date}`,
  canSubscribeAnytime: 'Puedes contratar un plan en cualquier momento.',
  daysRemainingInTrial: (days: number) =>
    ` Te quedan ${days} día${days !== 1 ? 's' : ''} de prueba.`,
  trialReplacedOnPay: ' Al pagar, tu plan de prueba se reemplazará por el plan que elijas.',
  defaultPlanName: 'Estándar',
} as const;

export const subscriptionPlanCard = {
  mostPopular: 'MÁS POPULAR',
  perMonth: 'por mes',
  petsLimit: (max: number) => `Hasta ${max} mascota${max !== 1 ? 's' : ''}`,
  aiUsagePerMonth: (limit: number) => `${limit} usos de resumen clínico por mes`,
  fullMedicalRecords: 'Gestión completa de fichas médicas',
  vaccinationHistory: 'Historial de vacunaciones',
  medicalControls: 'Controles médicos',
  automaticReminders: 'Recordatorios automáticos',
  filesPerPet: (max: number) => `Hasta ${max} archivo${max !== 1 ? 's' : ''} por mascota`,
  currentPlan: 'Plan Actual',
  blockedPlan: 'Plan Bloqueado',
  selectPlan: 'Seleccionar Plan',
  alreadySubscribed: 'Ya estás suscrito a este plan',
} as const;

export const paymentPage = {
  noPlanOrInvoice: 'No se especificó un plan o factura para procesar el pago',
  backToDashboard: 'Volver al Dashboard',
  confirmTitle: 'Confirmar Pago',
  monthlyRecurring: 'Suscripción mensual recurrente',
  secureProcessTitle: 'Proceso de pago seguro',
  transbankTip:
    'Asegúrate de tener tu tarjeta de crédito o débito lista. Webpay acepta todas las tarjetas bancarias chilenas.',
  mercadopagoTip:
    'Si estás en Chile en ambiente de producción, asegúrate de tener tu RUT configurado en tu perfil.',
  redirectSoon: 'Serás redirigido en un momento...',
  processErrorTitle: 'Error al procesar el pago',
} as const;

export const paymentHistory = {
  title: 'Historial de pagos',
  currentPlan: 'Plan actual',
  perMonth: '/mes',
  nextPayment: 'Próximo pago:',
  cardLabel: 'Tarjeta',
  loading: 'Cargando...',
  empty: 'Aún no tienes pagos registrados.',
  colPeriod: 'Periodo',
  colDate: 'Fecha',
  colAmount: 'Monto',
  colStatus: 'Estado',
  colDescription: 'Detalle',
  colReceipt: 'Comprobante',
  download: 'Descargar',
  receiptShort: 'Comprobante',
  freeAmount: 'Gratis',
  statusPaid: 'Pagado',
  statusPending: 'Pendiente',
  statusRejected: 'Rechazado',
  statusFreeChange: 'Cambio gratis',
  downloadError: 'No se pudo descargar el comprobante.',
  itemLabel: 'pagos',
} as const;

export const myPaymentHistory = {
  loadError: 'Error al cargar historial de pagos',
  backToHome: 'Volver a inicio',
  title: 'Historial de Pagos',
  subtitle: 'Revisa el estado de tus pagos manuales de suscripción',
  filterAll: (total: number) => `Todos (${total})`,
  filterPending: 'Pendientes',
  filterApproved: 'Aprobados',
  filterRejected: 'Rechazados',
  emptyTitle: 'No hay pagos registrados',
  emptyFiltered: (status: string) => `No tienes pagos con estado "${status}"`,
  emptyDefault: 'Aún no has realizado ningún pago manual',
  statusPending: 'Pendiente',
  statusApproved: 'Aprobado',
  statusRejected: 'Rechazado',
  statusFreeChange: 'Cambio gratis',
  amountLabel: 'Monto:',
  paymentDateLabel: 'Fecha de pago:',
  transactionIdLabel: 'ID Transacción:',
  reviewedLabel: 'Revisado:',
  userNotesLabel: 'Tus notas:',
  adminNotesLabel: 'Notas del administrador:',
  viewReceipt: 'Ver comprobante',
  freeAmount: 'Gratis',
  providerPlanChange: 'Cambio de plan',
  providers: {
    khipu: 'Khipu',
    flow: 'Flow',
    mercadopago: 'Mercado Pago',
    transbank: 'Transbank',
  },
  itemLabel: 'pagos',
} as const;
